import Dialog from './Dialog';
import { BUTTONS_TYPE } from './constants';

export { BUTTONS_TYPE };
export default Dialog;
